module.exports = __webpack_public_path__ + "img/partner.098379da.jpg";